import { Component } from '@angular/core';
import { Router, UrlSerializer } from '@angular/router';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { IFileDownload, IExam } from 'src/app/interface/dto';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-exam-result-period',
  templateUrl: './exam-result-period.component.html',
  styleUrls: ['./exam-result-period.component.scss']
})
export class ExamResultPeriodComponent {
  exportedFile: IFileDownload = {
    fileName: '',
    size: 0,
    extension: '',
    file: undefined
  };
  exam: IExam = examDefault;
  period = '';
  dateOfWriting = '';
  skipImportCandidateData = false;
  excludeTestCandidates = true;
  includeContactDetails = false;
  constructor(private popoverRef: PopoverRef<ExamResultPeriodComponent>,
    private examService: ExamService, private router: Router,
    private snackBar: SnackbarService, private serializer: UrlSerializer,) { }
    
  async ngOnInit() {
    if (this.examService.selectedExams?.length === 1) {
      this.exam = this.examService.selectedExams[0];
      this.period = this.exam.session;
    }
  }
  close() {
    this.popoverRef.close();
  }

  async getResultReport() {

    const reportTree = this.router.createUrlTree([], {
      queryParams: {
        "period": this.period,
        "dateOfWriting": this.dateOfWriting,
        "skipImportCandidateData": this.skipImportCandidateData,
        "excludeTestCandidates": this.excludeTestCandidates,
        "includeContactDetails": this.includeContactDetails
      }
    });
    let params = this.serializer.serialize(reportTree).split('?', 2)[1];
    await this.examService.getExamResultPeriodReport(params).then((s: any) => {
      this.snackBar.success('Report Successfull');
      this.exportedFile = s;
    }).catch((e) => {
      console.log(e);
    });

  }
}
